import { UiTableHeader } from './UiTableHeader.component';
import { UiTableRow, UiTableRowLoader } from './UiTableRow.component';
import type { ReactNode } from 'react';
import React, { ComponentPropsWithRef, FC, useState } from 'react';
import { TableDataItem } from '@api/business/treatmentHook/useForecastTool';
import StickyHeader from '@components/StickyHeader/StickyHeader.component';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import classnames from 'classnames';

function buildLoadingTableContent() {
  const content: ReactNode[] = [];
  for (let i = 0; i < 7; i += 1) {
    content.push(<UiTableRowLoader key={i} uniquekey={`tableRow-${i}`} />);
  }
  return content;
}

type Props = ComponentPropsWithRef<'div'> & {
  tableData: Array<TableDataItem>;
  isLoading: boolean;
};

const UiTable: FC<Props> = ({ tableData, isLoading, className, ...rest }) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | undefined>(undefined);
  const isSmartphoneOrTablet = useIsBreakpointDown(Breakpoint.l);

  if (tableData.length === 0 && !isLoading) {
    return null;
  }

  function handleOnScroll(elementId: string) {
    const headerScroll = document.getElementById('ui-table-header');
    const tableScroll = document.getElementById('ui-table-content');

    if (headerScroll && tableScroll) {
      if (elementId === 'ui-table-header') {
        tableScroll.scrollLeft = headerScroll.scrollLeft;
      } else {
        headerScroll.scrollLeft = tableScroll.scrollLeft;
      }
    }
  }

  const rootClassName = classnames('ui-table-container', 'plc-mb-l', className);
  return (
    <div className={rootClassName} {...rest}>
      <StickyHeader
        containerClass=".ui-table-container"
        topComponentClass={isSmartphoneOrTablet ? '.plc-header' : '.plc-thematic-header'}
      >
        <div className="ui-table" id="ui-table-header" onScroll={() => handleOnScroll('ui-table-header')}>
          <table>
            <UiTableHeader hoveredIndex={hoveredIndex} isLoading={isLoading} setHoveredIndex={setHoveredIndex} />
          </table>
        </div>
      </StickyHeader>

      <div className="ui-table" id="ui-table-content" onScroll={() => handleOnScroll('ui-table-content')}>
        <table onMouseLeave={() => setHoveredIndex(undefined)}>
          <tbody>
            {isLoading
              ? buildLoadingTableContent()
              : tableData.map((row) => (
                  <UiTableRow
                    data={row}
                    hoveredIndex={hoveredIndex}
                    key={row.label}
                    setHoveredIndex={setHoveredIndex}
                  />
                ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export { UiTable };
